export default __webpack_public_path__ + "static/media/duitnow.b22302c5.svg";